import { ReactNode } from "react";
import { Navigate, useNavigate } from "react-router-dom";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "./useAuthContext";
import {
  PATH_AFFILIATE,
  PATH_AUTH,
  PATH_BANK,
  PATH_DASHBOARD,
  PATH_KYC,
  PATH_SALES,
} from "../routes/paths";
import { TabsData } from "../utils/common";

// ----------------------------------------------------------------------

type KycGuardProps = {
  children: ReactNode;
};

export default function KycGuard({ children }: KycGuardProps) {
  const { user, isAuthenticated, isInitialized } = useAuthContext();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (isAuthenticated && user.userType === "salesUser") {
    return <Navigate to={PATH_SALES.dashboard} />;
  }

  if (isAuthenticated && user.userType === "affiliate") {
    return <Navigate to={PATH_AFFILIATE.dashboard} />;
  }

  return <>{children}</>;
}
